import axios from 'axios'
import { DetailedPriceBreakdown } from '@/models/common/breakdown'
import config from '@/utils/config'

interface FetchByRatePlanRequest {
  propertyId: string
  session: string
  roomConfigurations: Record<string, {
    ratePlanID: string
    roomID: string
  }>
}

type FetchByRatePlanResponse = {
  identifier: number
  roomID: number
  ratePlanID: number
  extrasPerRoomConfig: {
    extraID: number
    isFavourite: boolean
    availableQuantity: number
    minQuantity: number
    maxQuantity: number
    pricingType: number
    totalPrices: DetailedPriceBreakdown[]
  }[]
}[]

export async function getByRatePlan(
  req: FetchByRatePlanRequest
): Promise<FetchByRatePlanResponse> {
  return (await axios.post(
    `${config.searchAndBookApi}v1/accommodation/search/${req.propertyId}/extras`,
    req,
    { params: { showdailyprices: false } }
  )).data
}
